import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

function* loadContractorQuota(action) {
    const {
      data: {
        page,
        page_size,
        order_by,
        order_type,
        accessToken,
        filter_obj,
        type,
        file_value_pdf,
        limit_export,
      },
    } = action.payload
  
    try {
      const res = yield call(
        axios.post,
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/get-contractor-quota-list`,
        {
          page,
          page_size,
          order_by,
          order_type,
          filter_obj,
          type,
          file_value_pdf,
          limit_export,
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      )
      yield put(actions.loadContractorQuota.success(res.data, page))
    } catch (err) {
      console.log(err.message)
      yield put(actions.loadContractorQuota.failure())
    }
}

function* exportContractorQuota(action) {
    const {
      data: {
        page,
        page_size,
        order_by,
        order_type,
        accessToken,
        filter_obj,
        type,
        file_value_pdf,
        limit_export,
      },
    } = action.payload
  
    try {
      const res = yield call(
        axios.post,
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/get-contractor-quota-list`,
        {
          page,
          page_size,
          order_by,
          order_type,
          filter_obj,
          type,
          file_value_pdf,
          limit_export,
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      )
      yield put(actions.exportContractorQuota.success(res.data, page))
      const sftpPath = res.data.data
      const downloadRes = yield call(
        axios.post,
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
        { sftp_path: sftpPath },
        { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
      )
      const ext = sftpPath.split('.').pop().toLowerCase()
      const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const blob = new Blob([downloadRes.data], { type: mimeType })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = sftpPath.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    } catch (err) {
      console.log(err.message)
      yield put(actions.exportContractorQuota.failure())
    }
}

// *load ข้อมูลต้นแหล่ง
function* loadOriginLocationList(action) {
  const {
    data: { location_visibility, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/get-origin-location`,
      { location_visibility },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.loadOriginLocationList.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadOriginLocationList.failure())
  }
}

// *load ข้อมูลวัตถุดิบ for edit
function* loadMaterialList(action) {
  const {
    data: { material_visibility, locations_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/get-material`,
      { material_visibility, locations_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.loadMaterialList.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadMaterialList.failure())
  }
}

function* loadMaterialEditList(action) {
  const {
    data: { material_visibility, locations_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/get-material`,
      { material_visibility, locations_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.loadMaterialEditList.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadMaterialEditList.failure())
  }
}

function* loadContractorList(action) {
  const {
    data: { company_id_list, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/get-contractor`,
      { company_id_list },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    yield put(actions.loadContractorList.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadContractorList.failure())
  }
}

function* createContractorQuota(action) {
  const {
    data: { 
      company_id, 
      locations_id, 
      material_id,
      vehicle_quota,
      start_date,
      end_date,
      priority,
      accessToken },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/create-contractor-quota`,
      {
        company_id, 
        locations_id, 
        material_id,
        vehicle_quota,
        start_date,
        end_date,
        priority,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    loading(res.data)
    yield put(actions.createContractorQuota.success(res.data))
  } catch (err) {
    yield put(actions.createContractorQuota.failure())
  }
}

function* updateContractorQuota(action) {
  const {
    data: { data, accessToken },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/update-contractor-quota`,
      { data },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    yield put(actions.updateContractorQuota.success(res.data))
  } catch (err) {
    yield put(actions.updateContractorQuota.failure())
  }
}

function* contractorQuotaPreview(action) {
  const {
    data: { accessToken, company_id, locations_id, material_id, start_date, end_date },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-material-quota/contractor-quota-preview`,
      { company_id, locations_id, material_id, start_date, end_date },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.contractorQuotaPreview.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.contractorQuotaPreview.failure())
  }
}


export default function* watchContractorQuota() {
    yield all([
        takeEvery(actions.LOAD_CONTRACTOR_QUOTA.REQUEST, loadContractorQuota),
        takeEvery(actions.EXPORT_CONTRACTOR_QUOTA.REQUEST, exportContractorQuota),
        takeEvery(actions.CONTRACTOR_QUOTA_ORIGIN_LOCATION.REQUEST, loadOriginLocationList),
        takeEvery(actions.CONTRACTOR_QUOTA_MATERIAL.REQUEST, loadMaterialList),
        takeEvery(actions.LOAD_CONTRACTOR.REQUEST, loadContractorList),
        takeEvery(actions.CREATE_CONTRACTOR_QUOTA.REQUEST, createContractorQuota),
        takeEvery(actions.UPDATE_CONTRACTOR_QUOTA.REQUEST, updateContractorQuota),
        takeEvery(actions.CONTRACTOR_QUOTA_PREVIEW.REQUEST, contractorQuotaPreview),
        takeEvery(actions.CONTRACTOR_QUOTA_MATERIAL_EDIT.REQUEST, loadMaterialEditList),
    ])
}
export {
    loadContractorQuota,
    exportContractorQuota,
    loadOriginLocationList,
    loadMaterialList,
    loadContractorList,
    createContractorQuota,
    updateContractorQuota,
    contractorQuotaPreview,
    loadMaterialEditList
}